import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22.006 20.887 22 30.91a1.989 1.989 0 1 0 3.979 0V20.886a1.985 1.985 0 1 0-3.972 0m5.972 0V30.91a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001m-17.972 0L10 30.91a1.989 1.989 0 1 0 3.979 0V20.886a1.985 1.985 0 1 0-3.972 0m5.972 0V30.91a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001m18.028 0L34 30.91a1.989 1.989 0 1 0 3.979 0V20.886a1.985 1.985 0 1 0-3.972 0m5.972 0V30.91a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001M41 38.901H7.001A1 1 0 0 0 6 39.904l.002 1.19a1 1 0 0 0 .906.993 180 180 0 0 0 34.189 0 1 1 0 0 0 .905-.997L42 39.9a1 1 0 0 0-1-.998m3 .993.002 1.191a3 3 0 0 1-2.716 2.993q-8.653.822-17.29.822-8.64 0-17.278-.823a3 3 0 0 1-2.716-2.98L4 39.908A3 3 0 0 1 6.995 36.9H41a3 3 0 0 1 3 2.994m-1.994-27.517a1 1 0 0 0-.699-.954l-17.01-5.377a1 1 0 0 0-.602 0l-16.99 5.358a1 1 0 0 0-.699.954v.043c0 .281.228.508.508.508a17631 17631 0 0 1 34.993 0 .5.5 0 0 0 .499-.498zm2 0v.034a2.5 2.5 0 0 1-2.498 2.498 17725 17725 0 0 0-34.992 0 2.51 2.51 0 0 1-2.51-2.506v-.045a3 3 0 0 1 2.098-2.861l16.989-5.359a3 3 0 0 1 1.807 0l17.01 5.378a3 3 0 0 1 2.096 2.86",
      clipRule: "evenodd"
    }
  )
);
var SvgCompanyOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CompanyOutlined_default = SvgCompanyOutlined;

export { CompanyOutlined_default as default };
